import React from 'react';
import { Link } from '@inertiajs/react';
import useRoute from '@/Hooks/useRoute';
import IconPHP from '@/svgs/logo-php.svg?react';
import IconJs from '@/svgs/logo-js.svg?react';
import IconCss from '@/svgs/logo-css.svg?react';

interface Icons {
  [key: string]: JSX.Element;
}

export default function FilePill({ file }: { file: App.Data.FileData }) {
  const route = useRoute();

  const icons: Icons = {
    php: <IconPHP />,
    js: <IconJs />,
    css: <IconCss />,
  };

  return (
    <Link className="pill" href={route('snippet.show', { file: file.id })}>
      {icons[file.extension] ?? <IconCss />}
      {file.path}
    </Link>
  );
}
